// TODO: Update these I just copied from react-native
const h1TextStyle =
  'font-sans-bold text-32px text-gray-900 leading-9.5 tracking-tighter';
const h2TextStyle =
  'font-sans-bold text-28px text-gray-900 leading-8 tracking-tighter';
const h3TextStyle =
  'font-sans-bold text-2xl text-gray-900 leading-7 tracking-tighter';
const h4TextStyle =
  'font-sans-bold text-xl text-gray-900 leading-6 tracking-tight';
const h5TextStyle =
  'font-sans-semibold text-lg text-gray-900 leading-6 tracking-tight';
const h6TextStyle =
  'font-sans-semibold text-base  text-gray-900 leading-5 tracking-tight';
const h7TextStyle = 'font-sans-semibold text-sm text-gray-900 leading-4.5';
const h8TextStyle = 'font-sans-semibold text-13px text-gray-900 leading-4';
const h9TextStyle =
  'font-sans-semibold text-xs text-gray-900 leading-3.5 tracking-tight';

const p1TextStyle = 'font-sans text-xl text-gray-900 leading-7 tracking-tight';
const p2TextStyle = 'font-sans text-lg text-gray-900 leading-6 tracking-tight';
const p3TextStyle =
  'font-sans text-base text-gray-900 leading-5.5 tracking-tight';
const p4TextStyle = 'font-sans text-15px text-gray-900 leading-5';
const p5TextStyle = 'font-sans text-sm text-gray-900 leading-5';
const p6TextStyle = 'font-sans text-13px text-gray-900 leading-4.5';
const p7TextStyle = 'font-sans text-xs text-gray-900 leading-4';

export {
  h1TextStyle,
  h2TextStyle,
  h3TextStyle,
  h4TextStyle,
  h5TextStyle,
  h6TextStyle,
  h7TextStyle,
  h8TextStyle,
  h9TextStyle,
  p1TextStyle,
  p2TextStyle,
  p3TextStyle,
  p4TextStyle,
  p5TextStyle,
  p6TextStyle,
  p7TextStyle,
};
